import { render, staticRenderFns } from "./SmsTemplateAdd.vue?vue&type=template&id=95055096&scoped=true"
import script from "./SmsTemplateAdd.vue?vue&type=script&lang=js"
export * from "./SmsTemplateAdd.vue?vue&type=script&lang=js"
import style0 from "./SmsTemplateAdd.vue?vue&type=style&index=0&id=95055096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95055096",
  null
  
)

export default component.exports